import script from "./item.vue?vue&type=script&setup=true&lang=js"
export * from "./item.vue?vue&type=script&setup=true&lang=js"

import "./item.vue?vue&type=style&index=0&id=ad8e737a&lang=scss"

const __exports__ = script;

export default __exports__